export default __webpack_public_path__ + "static/media/more-about-me-icon.9256344b.svg";